import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalData } from '../models/index';
import { ThemeSelectorService } from 'src/app/services';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})

export class ModalComponent implements ModalData {
  title: string;
  content: string;
  closeBtnName: string;
  closeFunction: any;
  acceptBtnName = 'Confirm';
  acceptFunction: any;
  // OPTIONAL CALL TO ACTION (PARKING)
  optionalCta: boolean = false;
  optionalCtaTitle: string;
  optionalCtaFunction: any;

  constructor(public bsModalRef: BsModalRef,
              private themeSelector: ThemeSelectorService) {
  }

  accept() {
    this.bsModalRef.hide();
    if (this.acceptFunction) {
      this.acceptFunction();
    }
  }

  close() {
    this.bsModalRef.hide();
    if (this.closeFunction) {
      this.closeFunction();
    }
  }

  callToAction() {
    this.bsModalRef.hide();
    if (this.optionalCta && this.optionalCtaFunction) {
      this.optionalCtaFunction();
    }
  }

  getTheme() {
    return this.themeSelector.isDarkTheme;
  }

}

